import "./Topnav.css";

const Topnav = () => {

return (

<div>

<div className="topnav">
<div className="topnav-center">
<li><a>LIMITED TIME OFFER: UP TO 30% OFF SHOP NOW * T & C</a></li>
</div>
</div>

</div>

);
};

export default Topnav;